/* =========================================================
   global.js — small entry point loaded on every page.
   Add custom JS here or split into separate asset files.
   ========================================================= */

(function () {
  'use strict';

  // Example: highlight the skip link target on focus for accessibility.
  document.addEventListener('DOMContentLoaded', function () {
    var skipLink = document.querySelector('.skip-to-content-link');
    if (!skipLink) return;

    skipLink.addEventListener('click', function () {
      var target = document.getElementById('MainContent');
      if (target) {
        target.setAttribute('tabindex', '-1');
        target.focus();
      }
    });
  });
})();
